// Bestilleren må ha lagret kort for å publisere, med mindre organisasjonen betaler.
// Samme krav håndheves i Firestore-reglene ved opprettelse av oppdrag.
export function needsCardToPublish({ userDoc, payerType }) {
  return payerType !== 'org' && !userDoc?.stripeDefaultPaymentMethod;
}
